import React from "react"
import { Switch, Route, Redirect } from "react-router-dom"
import { TransitionRoute, Header, TabBar, TabLink, Wrapper } from "../lib"
import Billing from "./billing/Billing"
import Invoices from "./invoices/Invoices"
import Users from "./users/Users"

const Account = ({ match }) => {
  // TODO: usage, invoices
  return (
    <div className="Account">
      <Header title="Account">
        <TabBar>
          <TabLink to={`${match.url}/billing`} label="Billing" />
          <TabLink to={`${match.url}/invoices`} label="Invoices" />
          <TabLink to={`${match.url}/users`} label="Users" />
        </TabBar>
      </Header>
      <Wrapper>
        <Switch>
          <TransitionRoute path={`${match.path}/billing`} component={Billing} />
          <TransitionRoute
            path={`${match.path}/invoices`}
            component={Invoices}
          />
          <TransitionRoute path={`${match.path}/users`} component={Users} />
          <Route
            path="/account"
            exactly
            render={() => <Redirect to={`${match.url}/billing`} />}
          />
        </Switch>
      </Wrapper>
    </div>
  )
}

Account.displayName = "Account"

export default Account



// WEBPACK FOOTER //
// ./src/account/Account.js